// const exportUrl="http://127.0.0.1:8000/";
// const exportUrl="https://microfinance.amyfintech.com/backend/public/";
// const exportUrl = "https://drnwealthgroup.amyfintech.com/backend/public/";
const exportUrl="https://microfinance.msrcrestcapital.com/backend/public/";
// const exportUrl="https://nalanfs.com/finance/backend/public/";

export default exportUrl;
